import React, { useState } from "react";
import { useIntl } from "react-intl";

export default function QuestionsAndResponses({
	responses,
}: {
	responses?: {
		CategoryDimension: string;
		CategoryDimensionOption: string;
		Value: string | null;
	}[];
}) {
	const intl = useIntl();

	return (
		<div className="mb-3">
			{responses && responses.length > 0 ? (
				<table className="table table-sm">
					<thead>
						<tr>
							<th>{intl.formatMessage({ id: "category_option" })}</th>
							<th>{intl.formatMessage({ id: "category_option_question" })}</th>
							<th>{intl.formatMessage({ id: "category_option_question_value" })}</th>
						</tr>
					</thead>
					<tbody>
						{responses.map((response, index) => (
							<tr key={index}>
								<td>{response.CategoryDimension}</td>
								<td>{response.CategoryDimensionOption}</td>
								<td>{response.Value ?? ""}</td>
							</tr>
						))}
					</tbody>
				</table>
			) : (
				<p>{intl.formatMessage({ id: "no_responses_found" })}</p>
			)}
		</div>
	);
}
